import styles from './barStyles.module.scss';
import { useEditor } from '@craftjs/core';
import { FC, ReactNode, useCallback } from 'react';
import { UIEditorSaveResetControls } from 'src/components/formEditor/toolbox/saveResetComponent/UIEditorSaveResetControls';
import { StudyNameComponent } from 'src/components/studyName/studyName.component';
import { useContextSelector } from 'use-context-selector';
import { ScoreContext } from '../../context/score.context';
import { SaveFormParams } from '../generalFormBuilder.t';
import { useGeneralFormFillingModal } from '../../fillingModal/useGeneralFormFillingModal';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { AttachmentsContext } from '../../context/attachments.context';

export const TopBar: FC<{
  onSave: (params: SaveFormParams) => Promise<void>;
  onSaveAs?: (params: SaveFormParams) => Promise<void>;
  onDelete?: () => Promise<void>;
  configSelectorComponent: ReactNode;
}> = ({ onSave, onSaveAs, onDelete, configSelectorComponent }) => {
  const { t } = useScopedTranslation('GeneralFormBuilder.TopBar');
  const { query } = useEditor();
  const { variables, scoreSections } = useContextSelector(ScoreContext, (x) => x);
  const { attachments } = useContextSelector(AttachmentsContext, (x) => x);

  const { modal, open } = useGeneralFormFillingModal({ processAnswerFunc: undefined, uploadFileFunc: undefined });

  const { uploadFiles, downloadFiles } = useContextSelector(AttachmentsContext, (x) => x);

  const openPreview = useCallback(() => {
    open({
      initialValue: undefined,
      layout: query.getSerializedNodes(),
      modalTitle: t('PreviewModalTitle'),
      scoreSections: scoreSections ?? [],
      variables: variables ?? [],
      resultId: undefined,
      initialAttachments: attachments,
    });
  }, [attachments, open, query, scoreSections, t, variables]);

  return (
    <>
      <div className={styles.topBar}>
        <div className={styles.leftComponent}>
          <StudyNameComponent />
          {configSelectorComponent}
        </div>

        <UIEditorSaveResetControls
          isShowControls={true}
          save={async () => {
            await uploadFiles?.();
            await onSave({ nodes: query.getSerializedNodes(), scoreSections, variables });
          }}
          saveAs={
            onSaveAs
              ? async () => {
                  await uploadFiles?.();
                  await onSaveAs({ nodes: query.getSerializedNodes(), scoreSections, variables });
                }
              : undefined
          }
          downloadImages={downloadFiles}
          disabled={false}
          canDelete={!!onDelete}
          delete={onDelete}
          onPreviewOpen={openPreview}
        />
      </div>
      {modal}
    </>
  );
};
